import { render, staticRenderFns } from "./RedeemedCouponCustomersModal.vue?vue&type=template&id=0a195dc2&"
import script from "./RedeemedCouponCustomersModal.vue?vue&type=script&lang=babel&"
export * from "./RedeemedCouponCustomersModal.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports